import { embedSearchWidgetRouteGroup } from '#/modules/embedSearchWidget/routing/embedSearchWidget.routes';
import { searchJobsRouteReference } from '#/modules/search/routing/search.routes';

export const embedSearchWidgetJobsRouteGroup =
  embedSearchWidgetRouteGroup.subgroup('jobs');

export const embedSearchWidgetSearchJobsRoute =
  embedSearchWidgetJobsRouteGroup.rootRoute(
    searchJobsRouteReference.searchParams,
  );

export const embedSearchWidgetViewJobRoute =
  embedSearchWidgetJobsRouteGroup.route(':jobId');
